import './styles.css';
import '../components/theme-toggle.js';
import '../components/firmware-tabs.js';
import { startVisitBeacon } from './visit-beacon.js';

startVisitBeacon();
